module.exports = __webpack_public_path__ + "img/openLink.1641520899224.jpg";